import { render, staticRenderFns } from "./ChoosePaymentMethod.vue?vue&type=template&id=505adec4&scoped=true&"
import script from "./ChoosePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./ChoosePaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505adec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
